import { Radio, Space } from 'antd';
import React from 'react';
import { Trans } from 'react-i18next';

import SearchParam from '../SearchParam';
import FilterButton from './FilterButton';

interface FilterRadioGroupProps {
  name: string;
}

const FilterRadioGroup: React.FC<FilterRadioGroupProps> = ({ name, children }) => {
  return (
    <Space direction="vertical">
      <Space direction="horizontal">
        <SearchParam name={name} onSetSearchParams={{ page: '1' }}>
          <Radio.Group>
            <Space direction="vertical">{children}</Space>
          </Radio.Group>
        </SearchParam>
      </Space>
      <SearchParam
        array
        name={name}
        onSetSearchParams={{ page: '1' }}
        valuePropName="disabledValue"
      >
        <FilterButton>
          <Trans>Limpar</Trans>
        </FilterButton>
      </SearchParam>
    </Space>
  );
};

export default FilterRadioGroup;
